/* global Cookies */

const banner = document.querySelector('[data-ref="site-banner"]');
const closeBtn = banner.querySelector('[data-ref="site-banner-close"');

const hideBanner = (event) => {
  event.preventDefault();
  banner.classList.remove('is-visible');
  Cookies.set('bannerDissmissal', 'true', {expires: 7});
};

const init = () => {
  // Don't show if cookie is set
  if (Cookies.get('bannerDissmissal') == 'true') {
    return;
  }

  if (banner) {
    banner.classList.add('is-visible');
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', hideBanner);
  }
};

init();
